import React from 'react'
import Login from '../Components/LoginFloder/Login'
import Header from '../Components/LoginFloder/Header'

const Signin = () => {
  return (
    <div>
        <Header />
        <Login />
    </div>
  )
}

export default Signin